
import { useSearchParams, usePathname } from "next/navigation";
import { useChangeSubscription } from "@/hooks/use-change-subscription";
import { useCallback } from "react";

interface userVipUpgradeProps {
  subscriptionCallback?: () => void;
  noLimitRoutePath?: boolean; // 不限制路由
}

export default function useVipUpgrade({ noLimitRoutePath, subscriptionCallback }: userVipUpgradeProps) {
  // 获取当前路由信息
  const pathname = usePathname();
  const searchParams = useSearchParams();
  /**
   * 检查是否在允许显示非强制弹窗的路由
   * 允许的路由：首页大厅、Casino子大厅、Casino容器详情
   * 个人中心：账户、交易记录、交易详情、游戏历史
   * VIP、代理、奖励中心详情页、活动中心列表页
   */
  const isAllowedRouteForNonForce = useCallback(() => {
    // 移除语言前缀，统一处理路由（如 /en/ -> /）
    const pathWithoutLocale = pathname.replace(/^\/(en|pt|hi|id|es|tr|vi)/, '') || '/';

    if ([
      '/vip', '/affiliate', '/reward',
      '/account', '/transaction-history', '/game-history',
      '/casino', '/casino/games/container',
      '/promotions'
    ].includes(pathWithoutLocale)) {
      return true;
    }

    // 只有在根路径下才允许
    if (pathWithoutLocale !== '/' && pathWithoutLocale !== '') {
      return false;
    }

    // 检查 menuTab 参数
    const menuTab = searchParams?.get('menuTab');

    // 允许：无 menuTab、menuTab=Explore、menuTab=Casino
    return !menuTab || menuTab === 'Explore' || menuTab === 'Casino';
  }, [pathname, searchParams]);

  useChangeSubscription('upgrade_reward_popup', () => {
    if ((noLimitRoutePath || isAllowedRouteForNonForce()) && typeof subscriptionCallback === 'function') {
      subscriptionCallback();
    }
  });
}